import { jsx as o } from "react/jsx-runtime";
const l = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...r,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "m11.644 10.805-.848.848-1.737-1.738-1.061-1.06-1.061 1.06-.244.244-1.41-4.873 4.885 1.399-.261.26-1.061 1.061 1.06 1.061 1.737 1.736.776-1.345-1.452-1.452 2.062-2.062-9.94-2.847 2.869 9.918 2.04-2.039 2.798 2.798 2.193-2.193-1.345-.776Z"
      }
    )
  }
);
export {
  l as WebAddress
};
